import { BaseResourceModel } from "./base-resource.model";
import { SolicitacaoClassificacao } from "./solicitacao-classificacao.model";
import { Classificacao } from './classificacao.model';
import { DescritorConteudo } from './descritor-conteudo.model';
import { RequerimentoRecursoDescritorConteudo } from "./requerimento-recurso-descritor-conteudo.model";
import { StatusClassificacaoEnum } from "../enums/status-classificacao.enum";

export class Recurso extends BaseResourceModel {

    constructor(
        public id?: number,
        public solicitacaoClassificacao?: SolicitacaoClassificacao,
        public classificacaoRequerimento?: Classificacao,
        public justificativaRequerimento?: string,
        public descritorConteudoRelations: RequerimentoRecursoDescritorConteudo[] = [],
        public statusDeferimento?: any,
        public classificacaoAtribuida?: Classificacao,
        public justificativaAnalise?: string,        
        public conteudoDocumentoRequerimento?: string,
        public descritoresConteudoAtribuidos?: DescritorConteudo[],
        public dataCriacao?: Date,
        
    ) {
        super();
    }

    static fromJson(jsonData: any): Recurso {
        return Object.assign(new Recurso(), jsonData);
    }

    static extractDescritoresRequerimento(data: Recurso) {
        return this.extractDescritoresRequerimentoByStatus(
            data, StatusClassificacaoEnum.PRETENDIDA_RECURSO);
    }
    
    static extractDescritoresRequerimentoByStatus(
        data: Recurso, statusClassificacao: StatusClassificacaoEnum
    ) {
        return data.descritorConteudoRelations
            .filter(obj => obj.statusClassificacao.id == statusClassificacao)
            .map( obj => obj.descritorConteudo)
    }

}
